module.exports = __webpack_public_path__ + "img/new-memoryshare-logo-white.f0f6382d.png";